<template>
  <div >
    <div class="bodyBox">
      <img src="https://www.lnkading.com/uploads/temp/loginbg.png" class="bodyBoxBg" />
      <div class="loginBox">
        <img src="../../../static/image/logoY.png" class="logo"/>
        <div class="loginType">
          <div :class='isloginPwd?"loginType1":""' @click="uploginType(true)">密码登录 <div :class='isloginPwd?"loginType1_1":"loginType1_2"'></div></div>
          <div :class='!isloginPwd?"loginType1":""' @click="uploginType(false)">短信登录<div :class='!isloginPwd?"loginType1_1":"loginType1_2"'></div></div>
        </div>
        <el-input placeholder="请输入手机号" v-model="phone"clearable class="phoneInput"></el-input><br />
        <el-input placeholder="请输入密码" v-model="pwd" show-password class="phoneInput"></el-input>
        <div class="wjPwd" >
          <div @click="register">忘记密码？</div>
          <div @click="register">免费注册</div>
        </div>
        <div class="login" @click="login" >登录</div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        phone:'',
        pwd:'',
        isloginPwd:true,//是否密码登录
        lastTime:0 //默认上一次点击时间为0

      }
    },
    //初始化
    created(){

    },
    methods:{
      // 修改登录方式
      uploginType:function(e){
        console.log(e)
        this.isloginPwd=e
      },
      //注册
      register(){
        this.$router.push("/register")
      },
      login(){
        //获取当前时间的时间戳
        let now = new Date().valueOf();
        //第一次点击
        if(this.lastTime == 0){
          console.log('触发事件');
          this.lastTime = now;
          this.$store.state.login=true
          localStorage.setItem("isLogin",true);
          this.$message({
            duration:2000,
            message: '登录成功',
            type: 'success'
          });
          setTimeout(this.index, 2000);
        }else{
          if((now-this.lastTime) > 2000){
        //重置上一次点击时间，2000是我自己设置的2秒间隔，根据自己的需要更改
            this.lastTime = now;
            console.log('间隔大于2秒，触发方法');
            this.$store.state.login=true
            this.$message({
              duration:2000,
              message: '登录成功',
              type: 'success'
            });
            setTimeout(this.index, 2000);
          }else{
            console.log('不触发');
          }
        }
      },
      index(){
        this.$router.push("/index")
      }
    }
  }
</script>

<style scoped>
  .bodyBox{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    overflow: hidden;
    border: 0px;
    padding: 0px;
    position: relative;
    background-color: #00FF00;
  }
  .bodyBoxBg{
    width: 100vw;
    height: 50vw;
    min-height: 100vh;
    min-width: 200vh;
  }
  .loginBox{
    width: 280px;
    height: 240px;
    padding: 30px;
    border-radius: 20px;
    position: absolute;
    top: calc(50vh - 130px);
    left:calc(50vw - 160px) ;
    background-color: rgba(255,255,255,0.4);
  }
  .logo{
    width: 80px;
    height: 80px;
    position: absolute;
    top: -40px;
    left: 130px;
  }
  .loginType{
    width: 280px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    height: 40px;
  }
  .loginType>div{
    cursor:pointer
  }
  .loginType1{
     color: #FD8723;
  }
  .loginType1_1{
    width: 35px;
    height: 3px;
    background-color: #FD8723;
    border-radius: 20px;
    margin: 3px auto;
  }
  .loginType1_2{
    width: 35px;
    height: 3px;
  }
  .phoneInput{
    width: 280px;
    margin-top: 5px;
    display: block;
  }
  .login{
    width: 280px;
    height: 40px;
    border-radius: 5px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    margin-top: 10px;
    background-image: linear-gradient(160deg, #271169 , #5A0B24 );
  }
  .wjPwd{
    width: 280px;
    height: 40px;
    color: #FD8723;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/shoppingMall/login.vue